<template>
  <div class="operate-column">
    <component
      :is="item.component"
      v-for="item in computedProps.items"
      :key="item.key"
      v-bind="item.props"
      v-on="item.on"
    >
      {{ item.render() }}
    </component>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'OperateColumn',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const defaultProps = {
      items: [{
        key: 'edit',
        component: () => import('@/components/BaseElButton.vue'),
        render: () => '編輯',
        props: {
          type: 'text',
          class: ['underline'],
        },
        on: {
          click: () => {
            emit('edit')
          },
        },
      },
      {
        key: 'delete',
        component: () => import('@/components/BaseElButton.vue'),
        render: () => '刪除',
        props: {
          type: 'text',
          class: ['underline', 'delete-btn'],
        },
        on: {
          click: () => {
            emit('delete')
          },
        },
      }],
    }

    const computedProps = computed(() => {
      const items = props.items.length > 0 ? props.items : defaultProps.items
      return {
        items,
      }
    })
    return {
      computedProps,
    }
  },
})
</script>

<style lang="postcss" scoped>
.delete-btn {
  @apply text-danger;
}

</style>
